<div class="pm-console-page" fxFlex fxLayout="column">
  <!-- Page Toolbar -->
  <kmt-page-header [title]="'LBL.ANALYTICS'"></kmt-page-header>

  <!-- Console Toolbar -->
  <div
    class="full-width full-height"
    fxLayout="row"
    fxLayoutGap="4px"
    fxLayoutAlign="start center"
  >
    <iframe
      width="100%"
      height="100%"
      frameBorder="0"
      [src]="analyticsUrl"
    ></iframe>
  </div>
</div>
